<template>
    <div class="fr btn-text">
        <button v-show="enabled" v-on:click="toggleDisabled" v-bind:class="{'btn-loading': loading}" class="btn btn-text btn-text--accent width-auto-min f-s-3" type="button">
            {{ trans('Disable Offer') }}
            <div v-if="loading" class="loader">
                <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                    <svg class="i-stroke-accent" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
                </div>
            </div>
        </button>
        <button v-show=" ! enabled" v-on:click="toggleEnabled" v-bind:class="{'btn-loading': loading}" class="btn btn-text btn-text--accent width-auto-min f-s-3" type="button">
            {{ trans('Enable Offer') }}
            <div v-if="loading" class="loader">
                <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                    <svg class="i-stroke-accent" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
                </div>
            </div>
        </button>
    </div>
</template>
<script>
import { offerStatusLink } from '../../routes';

export default {
    props: {
        offer: {
            type: Object
        }
    },
    data() {
        return {
            enabled: this.offer.status === 'enabled' ? true : false,
            loading: false
        }
    },
    methods: {
        toggleEnabled() {
            this.loading = true;
            window.axios
                .put(offerStatusLink(this.offer))
                .then(() => {
                    this.loading = false;
                    this.enabled = true;
                });
        },
        toggleDisabled() {
            this.loading = true;
            window.axios
                .delete(offerStatusLink(this.offer))
                .then(() => {
                    this.loading = false;
                    this.enabled = false;
                });
        },
    }
}
</script>